import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-0"}],["path",{"d":"M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z","key":"svg-1"}],["path",{"d":"M8 13h1v3h-1z","key":"svg-2"}],["path",{"d":"M12 13v3","key":"svg-3"}],["path",{"d":"M15 13h1v3h-1z","key":"svg-4"}]]

const IconFileBarcode = createReactComponent('outline', 'file-barcode', 'FileBarcode', __iconNode);

export default IconFileBarcode;